import { cn } from './utils';

export { cn };
export const categoryIcons = {
  bricolage: 'Hammer',
  'menage-cuisine': 'Sparkles',
  jardinage: 'Flower2',
  demenagement: 'Truck',
  plomberie: 'Wrench',
  electricite: 'Zap',
  peinture: 'PaintBucket',
  'cours-particuliers': 'GraduationCap',
  'coiffure-esthetique': 'Scissors',
  couture: 'Shirt',
  'informatique-telephonie': 'Laptop',
  'baby-sitting': 'Baby',
  'garde-animaux': 'PawPrint',
  autres: 'Sparkle',
};
